export default "__VITE_ASSET__89b1660a__"